export default {
    categoriesAll: 'All',
    socialShare: 'Share',
    socialTweet: 'Tweet',
    socialLikeIt: 'Like It',
    socialLinkIt: 'Link It',
    next: 'Next',
    prev: 'Previous',
};
